import { render, staticRenderFns } from "./MoreMenuApplicationPromo.vue?vue&type=template&id=6660db6e"
import script from "./MoreMenuApplicationPromo.vue?vue&type=script&lang=js"
export * from "./MoreMenuApplicationPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports